import { render, staticRenderFns } from "./coursepackages.vue?vue&type=template&id=7c09b376&scoped=true&"
import script from "./coursepackages.vue?vue&type=script&lang=js&"
export * from "./coursepackages.vue?vue&type=script&lang=js&"
import style0 from "./coursepackages.vue?vue&type=style&index=0&id=7c09b376&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c09b376",
  null
  
)

export default component.exports